import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment'

// Interfaces
import { ICarType } from '@app/interfaces/car-type.interface';

@Injectable({ providedIn: 'root' })
export class CarTypeService {

    constructor(private http: HttpClient) { }

    getAll(): Observable<ICarType[]> {
        return this.http.get<ICarType[]>(environment.apiUrl + "/car-types");
    }
}
